// A dónde volver después de entrar (decisión D49): el visitante toca "Confirmar pedido" en el carrito, entra con su
// celular (o crea la cuenta, o sigue con Google, que sale de la página) y la tienda lo devuelve al carrito, que se
// confirma solo si no cambió nada. Queda guardado en el celular un rato, por si tarda en llegarle el código.
import { borrar, guardar, leer } from './almacen';
import { claveLocal } from './tienda-actual';
import { rutaVolverTienda } from '../compartido';

const CLAVE = claveLocal('volver');
const VIGENCIA_MS = 30 * 60_000;

export interface Volver {
  ruta: string;
  /** Confirmar el pedido al llegar (si los precios y el stock siguen iguales). */
  confirmar: boolean;
}

interface Guardado extends Volver {
  hasta: number;
}

export function recordarVolver(ruta: string, opciones: { confirmar?: boolean } = {}, ahora = Date.now()): void {
  guardar(CLAVE, {
    ruta: rutaVolverTienda(ruta),
    confirmar: !!opciones.confirmar,
    hasta: ahora + VIGENCIA_MS,
  } satisfies Guardado);
}

export function leerVolver(ahora = Date.now()): Volver | null {
  const v = leer<Guardado>(CLAVE);
  if (!v || typeof v.ruta !== 'string' || !(v.hasta > ahora)) return null;
  return { ruta: rutaVolverTienda(v.ruta), confirmar: !!v.confirmar };
}

/** La ruta a la que volver (y la olvida). Null: no había nada pendiente. */
export function tomarVolver(ahora = Date.now()): Volver | null {
  const v = leerVolver(ahora);
  borrar(CLAVE);
  return v;
}

export const olvidarVolver = () => borrar(CLAVE);
